module.exports = __webpack_public_path__ + "static/ambient-31c7559c74ad2409a9ebe13c757d6e19.mp3";